import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const CheckPage = lazy(() => import('../pages/check/page'));
const ResultPage = lazy(() => import('../pages/result/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const DisclaimerPage = lazy(() => import('../pages/disclaimer/page'));
const CommercialLawPage = lazy(() => import('../pages/commercial-law/page'));
const Fib4CalculatorPage = lazy(() => import('../pages/fib4-calculator/page'));
const AboutFib4Page = lazy(() => import('../pages/about-fib4/page'));
const LiverProgressionPage = lazy(() => import('../pages/liver-progression/page'));
const LiverFunctionPage = lazy(() => import('../pages/liver-function/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/check',
    element: <CheckPage />,
  },
  {
    path: '/result',
    element: <ResultPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/disclaimer',
    element: <DisclaimerPage />,
  },
  {
    path: '/commercial-law',
    element: <CommercialLawPage />,
  },
  {
    path: '/fib4-calculator',
    element: <Fib4CalculatorPage />,
  },
  {
    path: '/about-fib4',
    element: <AboutFib4Page />,
  },
  {
    path: '/liver-progression',
    element: <LiverProgressionPage />,
  },
  {
    path: '/liver-function',
    element: <LiverFunctionPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
